import { toast } from "sonner";
import { apiErrorMessage } from "@/lib/api/errors";

/**
 * App-wide feedback toasts. Prefer this over inline "Saved" flashes, `alert()`
 * or silently closing a dialog.
 *
 * Mutations can also opt in declaratively — see `MutationMeta` in
 * `lib/queryClient.ts`: `useMutation({ ..., meta: { successMessage: "Saved" } })`.
 * Failed mutations without their own `onError` are toasted automatically.
 */
export const notify = {
  success(message: string, description?: string) {
    toast.success(message, { description });
  },
  /** Accepts an API error (axios) or a plain message. */
  error(error: unknown, fallback = "Something went wrong") {
    const message = typeof error === "string" ? error : apiErrorMessage(error, fallback);
    toast.error(message);
  },
  info(message: string, description?: string) {
    toast(message, { description });
  },
};
